module.exports = __webpack_public_path__ + "media/blog/right-028983ed.png";